export default (): Experiments => ({
  experimentsData: new Map<string, any>()
})
